import React from 'react'
import { Elements, RecurlyProvider as Provider } from '@recurly/react-recurly'
import PropTypes from 'prop-types'

import { RECURLY_ID } from '@/config'

export default function RecurlyProvider({ children }) {
  return (
    <Provider publicKey={RECURLY_ID} required={['cvv']}>
      <Elements>
        {children}
      </Elements>
    </Provider>
  )
}

RecurlyProvider.propTypes = {
  children: PropTypes.element.isRequired,
}
